import { Component, Input } from '@angular/core';
import { FormGroup, UntypedFormGroup } from '@angular/forms';

import { IconNameMap, FcpIconSVGColors, FcpIconSVGSizes } from 'fc-ui-components';

@Component({
    selector: 'fc-clara-gln-form',
    templateUrl: './gln-form.component.html',
    styleUrls: ['./gln-form.component.less'],
    standalone: false
})
export class GlnFormComponent {
    @Input() glnForm: UntypedFormGroup;
    // this boolean flag is used to determine if we want to use old html markup input for the form
    // or the newer ones (i e fc-input-old) which were styled during the referral signup project
    @Input() useFCDesignSystemComponents = false;

    iconMapName = IconNameMap;
    fcpIconSVGColors = FcpIconSVGColors;
    fcpIconSVGSizes = FcpIconSVGSizes;

    hasToShowError(name: string): boolean {
        return this.glnForm.get(name).invalid && this.glnForm.get(name).dirty;
    }

    get fcGln() {
        return this.glnForm.get('fcGln').value;
    }

    get useFcGln() {
        return this.glnForm.get('useFcGln').value;
    }

    public isFieldInvalid(form: FormGroup, field: string): boolean {
        return form.controls[field].invalid && (form.controls[field].dirty || form.controls[field].touched);
    }

    updateUseFcGln(value: boolean): void {
        this.glnForm.patchValue({ useFcGln: value });
    }
}
